import { Component } from '@angular/core';
import { CpCode } from './cp-codes.model';
import { BreadcrumbService } from '../../../../breadcrumb.service';
import { Message } from 'primeng/primeng';
import { RouterConst } from '../../../../globals/RoutersConst';
import { ClientsService } from '../../../../services/clients/clients.service';
import { CookieService } from 'ngx-cookie-service';
import { HttpClient } from '@angular/common/http';
import { DashboardDataService } from '../../../../services/dashboard-data.service';
import { WsService } from '../../../../services/websocket/WsService';
import { SuperClass } from '../../../../superclass/SuperClass';
import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from '@angular/forms';

@Component({
  selector: 'app-cp-codes',
  templateUrl: './cp-codes.component.html',
  styleUrls: ['./cp-codes.component.css'],
})
export class CpCodesComponent extends SuperClass {
  cpCodes: any;
  newCpCode: CpCode;
  selectedRow: any;
  newCpCodeForm: FormGroup;
  selectedRowForm: FormGroup;
  display = false;

  msgs: Message[] = [];

  constructor(
    private breadcrumbService: BreadcrumbService,
    private dashboardDataService: DashboardDataService,
    private clientsService: ClientsService,
    private wsService: WsService,
    private httpClient: HttpClient,
    private cookiesService: CookieService,
    private fb: FormBuilder,
  ) {
    super(
      clientsService,
      wsService,
      dashboardDataService,
      httpClient,
      cookiesService,
    );

    this.breadcrumbService.setItems([
      { label: 'Organization' },
      { label: 'Vocabularies' },
      {
        label: 'CP Codes',
        routerLink: [{ outlets: { sub: [RouterConst.CP_CODES] } }],
      },
    ]);
  }

  reloadData() {
    this.http_getAllCpCodes((data: any) => {
      this.cpCodes = data.payload;
    });

    this.selectedRowForm = this.fb.group({
      cpCode: new FormControl('', Validators.required),
    });

    this.newCpCodeForm = this.fb.group({
      cpCode: new FormControl('', Validators.required),
    });
  }

  selectRow(e) {
    console.log('E', e);
    this.selectedRow = new CpCode(e.data);
  }

  addNewCpCode() {
    this.display = true;
    this.newCpCode = new CpCode();
  }

  createNewCpCode() {
    this.http_addCpCode(this.newCpCode, (data: any) => {
      this.cpCodes = data.payload;
      this.showSuccessMessage('New CP Code has been created');
    });
    this.display = false;
  }

  deleteCpCode() {
    this.http_deleteCpCode(this.selectedRow, (data: any) => {
      this.cpCodes = data.payload;
      this.showSuccessMessage('CP Code has been removed');
    });
  }

  saveCpCode() {
    this.selectedRow.countryId = this.selectedRow.country
      ? this.selectedRow.country.id
      : null;
    this.http_updateCpCode(this.selectedRow, (data: any) => {
      this.cpCodes = data.payload;
      this.showSuccessMessage('CP Code has been updated');
    });
  }

  unselectRow() {
    this.selectedRow = undefined;
  }

  getWebSocketIdentifier(): string {
    return undefined;
  }
}



// WEBPACK FOOTER //
// /home/sgurin/IdeaProjects/cosy/cp-builder/src/app/components/organization/vocabularies/cp-codes/cp-codes.component.ts